import Vue from "vue";
import { instance } from "@/services/axios";
import VueCookies from "vue-cookies";
Vue.use(VueCookies);

export const state = () => ({
  custom_field: {
    default_field_product: [],
    custom_field_product: [],
    default_field_serial: [],
    custom_field_serial: [],
    is_set: 0,
  },
  custom_field_answer: {
    product: [
      {
        product_id: 0,
        default_field_ans: [],
        custom_field_ans: [],
        serial: [
          {
            serial_id: 0,
            default_field_serial_ans: [],
            custom_field_serial_ans: [],
          },
        ],
      },
    ],
  },
});

export const mutations = {
  UPDATE_CUSTOM_FIELD: (state, payload) => {
    state.custom_field = payload;
  },
  UPDATE_CUSTOM_FIELD_ANSWER: (state, payload) => {
    state.custom_field_answer = payload;
  },
};

export const actions = {
  async setCustomField(context, payload) {
    if (context.state.custom_field.is_set == 1)
      return context.state.custom_field;
    const res = await instance("/product/get_all_product_field_setting");

    res.data.detail.is_set = 1;
    context.commit("UPDATE_CUSTOM_FIELD", res.data.detail);
    return res.data.detail;
  },
  async setCustomFieldAnswer(context, payload) {
    const res = await instance.post(
      "/product/get_product_dynamic_field",
      payload
    );

    context.commit("UPDATE_CUSTOM_FIELD_ANSWER", res.data.detail);
    return res.data.detail;
  },
  async getDynamicFields(context, payload) {
    const custom_fields = await context.dispatch("setCustomField", payload);
    const {
      fields,
      body,
      products_id,
      serials_id,
      key_product_id,
      key_serial_id,
    } = payload;
    let is_serial_table = serials_id.length > 0 ? true : false;
    const answer = await context.dispatch("setCustomFieldAnswer", {
      products_id,
      serials_id,
    });
    return setFieldsColumn(
      custom_fields,
      fields,
      body,
      answer,
      key_product_id,
      is_serial_table,
      key_serial_id
    );
  },
};
export const getters = {
  getProductCustomField: (state) => {
    return state.custom_field;
  },
  getProductCustomFieldAnswer: (state) => {
    return state.custom_field_answer;
  },
};
const setFieldsColumn = (
  custom_fields,
  fields,
  body,
  answer,
  key_product_id,
  is_serial_table,
  key_serial_id
) => {
  const fieldTypes = [
    { type: "default", fields: custom_fields.default_field_product },
    { type: "custom", fields: custom_fields.custom_field_product },
  ];
  const serialFieldsTypes = [
    { type: "default", fields: custom_fields.default_field_serial },
    { type: "custom", fields: custom_fields.custom_field_serial },
  ];

  for (const { type, fields: fieldList } of fieldTypes) {
    for (const field of fieldList) {
      let isSerial = is_serial_table
        ? field.is_display_serial
        : field.is_display;
      if (isSerial && !fields.some((el) => el.id === field.id)) {
        fields.push({
          key: `product.${type}.field-${field.id}`,
          label: field.description || field.name,
          sortable: false,
          id: field.id,
          thClass: "text-nowrap",
          class: `product.${type}.field-${field.id} w-100px`,
        });
      }
    }
  }
  if (is_serial_table) {
    for (const { type, fields: fieldList } of serialFieldsTypes) {
      for (const field of fieldList) {
        if (field.is_display && !fields.some((el) => el.id === field.id)) {
          fields.push({
            key: `serial.${type}.field-${field.id}`,
            label: field.description || field.name,
            sortable: false,
            id: field.id,
            thClass: "text-nowrap",
            class: `serial.${type}.field-${field.id} w-100px`,
          });
        }
      }
    }
  }

  const answerMap = new Map();
  for (const ans of answer.product) {
    answerMap.set(ans.product_id, ans);
  }

  for (const product of body) {
    const field_answer = answerMap.get(product[key_product_id || "product_id"]);

    if (!field_answer) continue;

    for (const { field_id, ans } of field_answer.default_field_ans || []) {
      let value = field_id == 14 ? (ans == 0 ? "Non-Serial" : "Serial") : ans;
      product[`product.default.field-${field_id}`] = value || "-";
    }
    for (const { field_id, ans } of field_answer.custom_field_ans || []) {
      product[`product.custom.field-${field_id}`] = ans || "-";
    }
    if (is_serial_table) {
      console.log(field_answer.serial);
      const f = field_answer.serial.find(
        (f) => f.serial_id === product[key_serial_id || "id"]
      );
      console.log(f);
      if (!f) continue;
      for (const { field_id, ans } of f.default_field_serial_ans || []) {
        product[`serial.default.field-${field_id}`] = ans || "-";
      }
      for (const { field_id, ans } of f.custom_field_serial_ans || []) {
        product[`serial.custom.field-${field_id}`] = ans || "-";
      }
      // product[`product.custom.field-${field_id}`] = ans || "-";
    }
  }

  return { fields, body };
};
export default {
  state,
  actions,
  mutations,
  getters,
};
